import { CREATE_USER_REQUEST, CREATE_USER_SUCCESS, CREATE_USER_FAILURE } from '../../actions/create-user';

export default (state = false, { type }) => {
  switch (type) {
    case CREATE_USER_REQUEST:
      return true;
    case CREATE_USER_SUCCESS:
    case CREATE_USER_FAILURE:
      return false;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/auth/is-authenticating.js